function setCookie(name, value, days = 7) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
}

function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

if (window.location.pathname === '/') {
  const locationUrl = getCookie('location_url');
  if (locationUrl) {
    window.location.href = locationUrl;
  }
}

$(document).ready(function () {

  const currentDomain = window.location.hostname;
  const rootDomain = currentDomain.split('.').slice(-2).join('.');

  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href').trim();


    if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

    try {
      const url = new URL(href, window.location.origin);
      const linkDomain = url.hostname.split('.').slice(-2).join('.');

      if (linkDomain === rootDomain) return;


      if (trustedDomains.some(domain => domain.includes(linkDomain))) return;

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

    } catch (e) {
      // link failed to add _blank
    }
  });



  $(document).on("click", ".header-topmenu a, .mobile-topmenu a", function (e) {
    const href = $(this).attr('href');
    if (href === '/') {
      deleteCookie('location_url');
    }
  });

  /* Sorting list js */
  $(document).on("click", ".listing-sort .select-dropdown__list-item", function (e) {
    var $li = $(this).parents('li');
    var itemValue = $li.data('value');
    var itemName = $(this).text().trim();
    var $filter = $(this).closest(".filter-sort");
    var $label = $filter.find('.select-text');
    var currentValue = $label.text().trim();
    $('.facet-filters__sort').val(itemValue);
    if (currentValue === itemName) {
      // If same item is clicked again → reset
      $label.text("Sort");
      $filter.removeClass('active');
    } else {
      // Otherwise → set new value
      $label.text(itemName);
      $filter.addClass('active');
    }
    var facetForm = document.querySelector('#FacetFiltersForm')
    const inputEvent = new Event('input', {
      bubbles: true,  // Ensures the event bubbles up to ancestors
      cancelable: true,  // Allows the event to be canceled if needed
    });

    // Dispatch the event on the form
    facetForm.dispatchEvent(inputEvent);
  });

});


function formatDateUTCCustom(dateString, timezone) {
  if (!dateString) return '';

  const date = new Date(dateString);

  const datePart = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone || 'UTC',
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).format(date);


  const timePart = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone || 'UTC',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
    .format(date)
    .toLowerCase();

  return `${datePart} @ ${timePart}`;
}

function getTZOffsetMinutes(timeZone, date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(date);

  const map = {};
  parts.forEach(p => map[p.type] = p.value);

  const tzDate = new Date(
    `${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`
  );

  return (tzDate - date) / 60000;
}

function dateInTimezoneToUTC(dateStr, timeZone, endOfDay = false) {
  const [y, m, d] = dateStr.split('-').map(Number);

  const localDate = new Date(
    y,
    m - 1,
    d,
    endOfDay ? 23 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 59 : 0
  );

  const offset = getTZOffsetMinutes(timeZone, localDate);
  localDate.setMinutes(localDate.getMinutes() - offset);

  return localDate.toISOString();
}

function addCurrentUTMsToNewUrl(url) {
  const parsedUrl = new URL(url);
  const params = new URLSearchParams(window.location.search);
  
  const utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ];
  
  const utmParams = {};
  utmKeys.forEach(key => {
    if (params.has(key)) {
      utmParams[key] = params.get(key);
    }
  });

  Object.entries(utmParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      parsedUrl.searchParams.set(key, value);
    }
  });
  
  return parsedUrl.toString();
}
